import { FC } from 'react';
import { Add as AddIcon } from '@mui/icons-material';
import { Button } from '@mui/material';
import { useHandleClickDialog } from 'layouts/Main/components';
import { FIRM_SUMMARY_ADD_COMPANY_TITLE } from 'pages/Firms/common/constants';

const AddCompanyButton: FC = () => {
  const openNewCompanyDialog = useHandleClickDialog();

  return (
    <Button color="primary" endIcon={<AddIcon />} onClick={openNewCompanyDialog} variant="outlined">
      {FIRM_SUMMARY_ADD_COMPANY_TITLE}
    </Button>
  );
};

export default AddCompanyButton;
